import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UIState } from "../types/ui";

const initialState: UIState = {
  currentStep: 1,
  isDirty: false,
  errors: [],
  warnings: [],
  isStepComplete: false,
  isSidebarOpen: false,
  selectedSystem: null,
  validationErrors: [],
  validationWarnings: [],
  isDarkMode: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setUICurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    setIsDirty: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload;
    },
    setErrors: (state, action: PayloadAction<string[]>) => {
      state.errors = action.payload;
    },
    setWarnings: (state, action: PayloadAction<string[]>) => {
      state.warnings = action.payload;
    },
    setIsStepComplete: (state, action: PayloadAction<boolean>) => {
      state.isStepComplete = action.payload;
    },
    clearErrors: (state) => {
      state.errors = [];
    },
    setIsSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload;
    },
    setSelectedSystem: (state, action: PayloadAction<string | null>) => {
      state.selectedSystem = action.payload;
    },
    setValidationErrors: (state, action: PayloadAction<string[]>) => {
      state.validationErrors = action.payload;
    },
    setValidationWarnings: (state, action: PayloadAction<string[]>) => {
      state.validationWarnings = action.payload;
    },
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
    },
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.isDarkMode = action.payload;
    },
  },
});

export const {
  setUICurrentStep,
  setIsDirty,
  setErrors,
  setWarnings,
  setIsStepComplete,
  clearErrors,
  setIsSidebarOpen,
  setSelectedSystem,
  setValidationErrors,
  setValidationWarnings,
  toggleDarkMode,
  setDarkMode,
} = uiSlice.actions;
export default uiSlice.reducer;
